import * as angular from 'angular';
import { KendoReactDropDownButtonBridge } from './KendoReactDropDownButtonBridge';

angular
  .module('flowingly.components')
  .component('kendoReactDropDownButton', KendoReactDropDownButtonBridge);
